import React, { useEffect, useState } from "react";
import axios from "axios";
import EnvironmentReleaseList from "../components/EnvironmentReleaseList";
import { Environment } from "../_generated";
import { BackendURL } from "../globals";
import { authToken } from "../components/Authentication";
import analytics from "../analytics";

export default function EnvironmentActivityPage({
  projectName,
  environment,
}: {
  projectName: string;
  environment: Environment;
}) {
  const [releases, setReleases] = useState([]);
  const apiRoot = `${BackendURL}/api`;

  axios.defaults.headers.common["Authorization"] = `Bearer ${authToken}`;

  useEffect(() => {
    analytics.page("EnvironmentActivity");
  }, []);

  useEffect(() => {
    axios
      .get(
        //"https://run.mocky.io/v3/8831a754-a62f-496e-9f69-bf5af869437e"
        `${apiRoot}/projects/${projectName}/environments/${environment.pk}/releases/`
      )
      .then((response) => {
        setReleases(response.data.results);
      });
  }, [apiRoot, environment, projectName]);

  return <EnvironmentReleaseList releases={releases} />;
}
